var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClosedCaption = function SvgClosedCaption(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "closed_caption_svg__a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#fff",
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#closed_caption_svg__a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 40,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-130.643 0-237.246-107.445-235.989-238.318L-236-472l3.912 3.912c33.075 33.075 83.695 41.792 125.513 20.835C-74.925-463.116-39.111-472.018-1.054-472c129.907-.06 235.796 103.781 237.043 233.682C237.246-107.445 132.75 0 0 0Z",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(256 492)",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-27.223 27.336-71.36 27.336-98.583 0-27.223-27.337-27.223-71.658 0-98.995 27.223-27.337 71.36-27.337 98.583 0",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(221 296.498)",
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-27.223 27.336-71.36 27.336-98.583 0-27.223-27.337-27.223-71.658 0-98.995 27.223-27.337 71.36-27.337 98.583 0",
    style: {
      strokeWidth: 40,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(407 296.498)",
    "data-original": "#000000"
  })));
};
export default SvgClosedCaption;